import { render, staticRenderFns } from "./CustomerServicesRibbon.vue?vue&type=template&id=362fb373"
import script from "./CustomerServicesRibbon.vue?vue&type=script&lang=js"
export * from "./CustomerServicesRibbon.vue?vue&type=script&lang=js"
import style0 from "./CustomerServicesRibbon.vue?vue&type=style&index=0&id=362fb373&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports